export const gameConstants = {

    FETCH_GAME_REQUEST: 'FETCH_GAME_REQUEST',
    FETCH_GAME_SUCCESS: 'FETCH_GAME_SUCCESS',
    FETCH_GAME_FAILURE: 'FETCH_GAME_FAILURE',
    MARK_GAME_AS_PLAYED: 'MARK_GAME_AS_PLAYED',

    FETCH_BLOCKEDSTATUS_REQUEST: 'FETCH_BLOCKEDSTATUS_REQUEST',
    FETCH_BLOCKEDSTATUS_SUCCESS: 'FETCH_BLOCKEDSTATUS_SUCCESS',
    FETCH_BLOCKEDSTATUS_FAILURE: 'FETCH_BLOCKEDSTATUS_FAILURE',
    UPDATE_BLOCKEDSTATUS_FROM_SOCKET: 'UPDATE_BLOCKEDSTATUS_FROM_SOCKET',

    PURCHASE_GAME_REQUEST: 'PURCHASE_GAME_REQUEST',
    PURCHASE_GAME_SUCCESS: 'PURCHASE_GAME_SUCCESS',
    PURCHASE_GAME_FAILURE: 'PURCHASE_GAME_FAILURE',

}
